import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || null,
    bg: searchParams.get('bg') || null,

    title: getDefaultValue(searchParams.get('title'), 'Голосуйте!'),
    qrCode: searchParams.get('qrCode'),

    titleFontSize: searchParams.get('titleFontSize') || '4.8',
    sizeQR: searchParams.get('sizeQR') || '20',

    questionFontSize: searchParams.get('questionFontSize') || '4.8',
    answerFontSize: searchParams.get('answerFontSize') || '4.2',
    varNumFontSize: searchParams.get('varNumFontSize') || '6.2',
  };
};
